<template>
  <div class="grid md:grid-cols-2 sm:grid-cols-1 gap-4 md:mx-16 lg:mx-16 px-6 pt-10">
    <div class="mx-auto md:pt-5 w-80">
      <div class="w-44 m-auto">
       <img class="hidden md:block md:ml-1 xl:ml-2 w-30 sm:w-full md:mt-8" src="../assets/img_hugobot.png" alt="">
       <img class="hidden md:block md:ml-1 xl:ml-2 w-30 sm:w-full md:mt-8" src="../assets/Hugo_Logo.png" alt="">
      </div>
      <div class="flex md:hidden">
        <img class=" md:ml-1 xl:ml-2 w-14 sm:w-full md:mt-8" src="../assets/img_hugobot.png" alt="">
        <img class=" md:ml-1 xl:ml-2 w-18 h-8 sm:w-full ml-2 mt-4" src="../assets/Hugo_Logo.png" alt="">
      </div>
       <p class="text-yellow-400 md:text-2xl md:mt-10 md:text-center ml-16 md:ml-0 text-sm">I'm HUGO, Ask me anything</p>
    </div>
    <!-- ... -->
    <div>
      <chat-bot />
    </div>

  </div>

</template>
<script>
import ChatBot from "./ChatBot.vue";
export default {
  components: {
    ChatBot,
  },
};
</script>

<style scoped>
.bg-orange{
  background-color: #FBCFBC;
}
</style>
